import "./App.css";

import {
  useNavigationGamepad,
  useNavigationKeys,
} from "./lib/navigation/navigation.hooks";

import Examples from "./examples";

function App() {
  useNavigationKeys();
  useNavigationGamepad();

  return (
    <div className="App">
      <header className="App-header">redux-key-nav</header>
      <main>
        <Examples />
      </main>
    </div>
  );
}

export default App;
